import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApplicationResource, ApplicationsService} from "../../core/modules/openapi";
import {MatCard, MatCardContent, MatCardHeader, MatCardModule} from "@angular/material/card";
import {ApplicationMessagesComponent} from "../application-messages/application-messages.component";
import {statusEnumLookup} from "../applications-criteria/applications-criteria.component";
import {MatButton} from "@angular/material/button";
import {ApplicationOutlineComponent} from "../application-outline/application-outline.component";

@Component({
  selector: 'app-application-detail',
  imports: [
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardModule,
    ApplicationMessagesComponent,
    MatButton,
    ApplicationOutlineComponent
  ],
  templateUrl: './application-detail.component.html',
  standalone: true,
  styleUrl: './application-detail.component.sass'
})
export class ApplicationDetailComponent {
  applicationResource: ApplicationResource;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly applicationService: ApplicationsService
  ) {
  }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id')!;
    this.applicationService.getApplicationById(id).subscribe(response => {
      this.applicationResource = response;
    });
  }

  protected readonly statusEnumLookup = statusEnumLookup;

  retryAction(action: "issue" | "validate" | "print") {
    if (this.applicationResource.id) {
      this.applicationService.retryApplicationAction(this.applicationResource.id, action).subscribe();
      this.router.navigate(['home']);
    }
  }
}
